import { useParams } from 'react-router-dom'
import Button from '@/components/common/Button/Button'
import { FaArrowLeft } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import './ServiceDetail.css'

const ServiceDetail = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    
    return (
        <div className="service-detail-page">
            <div className="service-detail-container">
                <div className="service-detail-header">
                    <Button
                        variant="ghost"
                        onClick={() => navigate(-1)}
                        effect3d={false}
                    >
                        <FaArrowLeft />
                        Volver
                    </Button>
                    <h1 className="service-detail-title">Detalle del Servicio</h1>
                </div>
                
                <div className="service-detail-content">
                    <div className="service-detail-message">
                        <p>Cargando servicio #{id}...</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceDetail


